import { Box, theme } from '@bechtel/gds';
import { FC } from 'react';
import { Skeleton } from '../skeleton';
import { GridHeaderStyled } from './styled';

interface GridSkeletonProps {
  columns?: number;
  rows?: number;
}

export const GridSkeleton: FC<GridSkeletonProps> = ({ columns = 10, rows = 15 }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }} p={{ sm: '450' }} gap={{ sm: '450' }}>
      <GridHeaderStyled>
        <Skeleton width="20px" height="20px" borderRadius="200" />
        {Array.from({ length: columns - 1 }).map((item, index) => {
          return <Skeleton key={index} width="5%" height="20%" borderRadius="200" />;
        })}
      </GridHeaderStyled>
      <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
        {Array.from({ length: rows }).map((item, index) => {
          return (
            <Box key={index} style={{ height: '7%', borderBottom: `1px solid ${theme.colors.grey[200]}` }}>
              <GridRowSkeleton key={index} columns={columns}></GridRowSkeleton>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const GridRowSkeleton = ({ columns }) => {
  return (
    <Box flexGrow={{ sm: '1' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-around' }}>
      <Skeleton width="20px" height="20px" borderRadius="200" />
      {Array.from({ length: columns - 1 }).map((item, index) => {
        return <Skeleton key={index} width="5%" height="40%" borderRadius="200" />;
      })}
    </Box>
  );
};
